module.exports = __webpack_public_path__ + "static/media/se.b54f0ef0.svg";